export default __webpack_public_path__ + "static/media/pexels-adrianna-calvo-17679.5a75ef01.jpg";